'use strict'
import ViewBase from '../../../view-base.view'
import trainModel from "../../../../models/custom-vision/custom-vision.trains.model";

export default function CVTrainingRequestRejectView() {
    ViewBase.call(this);

    let inputDataModel = { reason: "" };

    let selectedTrainingRequestId = 0;

    let onPopupClose = (e) => { };
    let onSaveComplete = (e) => { };

    let _cancel = (e) => {
        onPopupClose(e);
    }

    let _save = (e) => {
        // Form validation
        if (!this.validateForm(e)) {
            return false;
        }

        trainModel.rejectTrainingRequest(
            (result) => {
                onSaveComplete(result);
            },
            (error) => {
                this.handleError(error);
            },
            selectedTrainingRequestId,
            inputDataModel.reason
        );  
    }
    
    let _getReason = (e) => {
        inputDataModel.reason = e.target.value;
    }

    return {
        oninit: (vnode) => {

            if (vnode.attrs.onPopupClose) {
                onPopupClose = vnode.attrs.onPopupClose;
            }
            if (vnode.attrs.onSaveComplete) {
                onSaveComplete = vnode.attrs.onSaveComplete;
            }
            if (vnode.attrs.trainingRequestId) {
                selectedTrainingRequestId = vnode.attrs.trainingRequestId;
            }

        },
        view: ({ attrs }) => {

            return [
                m('.row',
                    m('col-md-12', 
                        m('.card',
                            m('.card-body',
                                m('form#mainForm[novalidate].needs-validation', 
                                    m('.row.col-md-12',
                                        m('.col-md-12.mt-4', 
                                            m('span', this.getText("LT00000418", "Please key in the reason why you reject this training request."))
                                        ),
                                        m('.col-md-12.mt-4', 
                                            m('label.form-label', this.getText("LT00000419", "Reason"), m('span.text-danger', "*")), 
                                            m('textarea#txtContent[required].form-control.form-control-bg', 
                                                { 
                                                    placeholder: this.getText("LT00000419", "Reason"),
                                                    onchange: _getReason, 
                                                    style: "height: 185px;", 
                                                    maxlength: 500 
                                                },
                                                inputDataModel.reason
                                            ),
                                            m('.invalid-feedback', this.getText("LT00000418", "Please key in the reason why you reject this training request."))
                                        )
                                    )
                                )
                            ),
                            m('.card-footer',
                                m('.col-md-12 .gap-2 .d-flex .justify-content-end',
                                    m("button.btn.btn-danger[type='button']", { onclick: _save }, this.getText("LT00000420", "Reject Request")),
                                    m("button.btn.btn-white[type='button']", { onclick: _cancel }, this.getText("LT00000021", "Close"))
                                )
                            )
                        )
                    ),
                ),
                this.getBaseViews()
            ];
        },
    };
}
